// extracted by mini-css-extract-plugin
module.exports = {"Iframe":"FilesPopup_Iframe__3iNDn","Image":"FilesPopup_Image__1Dsg0"};